angular.module('elfium').directive('businessCaseListItem', ['elfiumUrlService', function (elfiumUrlService) {
    return {
        restrict: 'A',
        scope: {
        	businessCaseListItem: '=',
        	lastStage: '='
        },
        controller: 'businessCaseListItemController',
        templateUrl: elfiumUrlService.getTemplateUrl('businessCase', 'businessCaseListItem')
    };
}]);


// WEBPACK FOOTER //
// ./src/app/components/businessCase/businessCaseListItem.ts